import script from "./AdtList.vue?vue&type=script&lang=ts&setup=true"
export * from "./AdtList.vue?vue&type=script&lang=ts&setup=true"

import "./AdtList.vue?vue&type=style&index=0&id=23a2bf69&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23a2bf69"]])

export default __exports__